/* One-tap add for the cart drawer upsell row. Re-uses the theme's own cart drawer rendering. */
if (!customElements.get('cart-upsell')) {
  customElements.define('cart-upsell', class CartUpsell extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-upsell-add]');
        if (btn) this.add(btn);
      });
    }

    async add(btn) {
      if (btn.getAttribute('aria-disabled') === 'true') return;
      const cart = document.querySelector('cart-drawer');
      /* the cart page has no drawer: add, then reload so the page shows the new cart */
      const onCartPage = !cart && !!document.querySelector('cart-items');
      if (!cart && !onCartPage) return;
      const err = this.querySelector('.ipc-upsell__err');
      err.hidden = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('is-loading');

      try {
        const res = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({
            id: Number(btn.dataset.variantId),
            quantity: 1,
            ...(cart ? { sections: cart.getSectionsToRender().map((s) => s.id).join(','), sections_url: window.location.pathname } : {}),
          }),
        });
        const data = await res.json();
        if (data.status) throw new Error(data.description || data.message);

        if (onCartPage) { window.location.reload(); return; }
        cart.setActiveElement(document.activeElement);
        // renderContents swaps the drawer HTML, so this element is replaced - nothing to reset after.
        cart.renderContents(data);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: data, variantId: btn.dataset.variantId });
        }
        if (typeof freeShippMsg === 'function') freeShippMsg();
      } catch (e) {
        err.textContent = e.message || 'Could not add this item. Please try again.';
        err.hidden = false;
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('is-loading');
      }
    }
  });
}

/* Free-shipping card: celebrate once, at the moment the threshold is crossed (not on page load, not on every open). */
if (!customElements.get('ipc-track')) {
  customElements.define('ipc-track', class IpcTrack extends HTMLElement {
    connectedCallback() {
      const key = 'ipc_ship_unlocked';
      try {
        if (this.dataset.reached !== 'true') { sessionStorage.removeItem(key); return; }
        const seen = sessionStorage.getItem(key);
        sessionStorage.setItem(key, '1');
        if (!seen && document.readyState === 'complete') { this.classList.add('is-celebrate'); this.throwConfetti(); }
      } catch (e) { /* storage blocked: no celebration */ }
    }
    /* confetti thrown up and out from the end of the progress bar, then falling away */
    throwConfetti() {
      if (!this.animate || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
      const mark = this.querySelector('.ipc-track__mark:last-of-type') || this.querySelector('.ipc-track__bar') || this;
      const r = mark.getBoundingClientRect();
      const ox = r.left + r.width / 2, oy = r.top + r.height / 2;
      const layer = document.createElement('div');
      layer.setAttribute('aria-hidden', 'true');
      layer.style.cssText = 'position:fixed;left:0;top:0;width:100%;height:100%;pointer-events:none;overflow:hidden;z-index:2147483000';
      const colors = ['#1b6b48', '#e7a21a', '#14141a', '#e3b3bd', '#a9c3dc', '#f26b5b', '#7b61ff'];
      const rnd = (a, b) => a + Math.random() * (b - a);
      for (let i = 0; i < 46; i++) {
        const p = document.createElement('i');
        const w = rnd(6, 11), h = Math.random() < 0.5 ? w : rnd(3, 5), c = colors[i % colors.length];
        p.style.cssText = 'position:absolute;left:' + ox + 'px;top:' + oy + 'px;width:' + w + 'px;height:' + h + 'px;background:' + c + ';border-radius:' + (Math.random() < 0.35 ? '50%' : '2px') + ';opacity:0;will-change:transform,opacity';
        const dx = rnd(-210, 120), up = rnd(110, 300), fall = rnd(60, 260), rot = rnd(-540, 540);
        p.animate([
          { transform: 'translate(0,0) rotate(0deg)', opacity: 1 },
          { transform: 'translate(' + dx * 0.65 + 'px,' + -up + 'px) rotate(' + rot * 0.6 + 'deg)', opacity: 1, offset: 0.4 },
          { transform: 'translate(' + dx + 'px,' + fall + 'px) rotate(' + rot + 'deg)', opacity: 0 }
        ], { duration: rnd(1300, 2000), delay: rnd(0, 140), easing: 'cubic-bezier(.2,.7,.4,1)', fill: 'forwards' });
        layer.appendChild(p);
      }
      document.body.appendChild(layer);
      setTimeout(() => layer.remove(), 2400);
    }
  });
}
